import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Spinner } from "@/components/ui";

// Public live-demo entry: auto-signs in as a Care Manager (clinical-only view — no internal Business tabs)
// so it is safe to send to prospects like Trillium.
export default function Demo() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    (async () => {
      try { await login("carmen.reyes@gomco.ai", "Care123!"); } catch { /* noop */ }
      navigate("/dashboard", { replace: true });
    })();
  }, [login, navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4" style={{ background: "hsl(244,47%,6%)" }} data-testid="demo-launcher">
      <Spinner label="" />
      <p className="text-white/80 font-display text-lg">Launching your live Go MCO demo…</p>
      <p className="text-white/40 text-sm">A guided, care-manager view of the real platform.</p>
    </div>
  );
}
